<template>
  <form @submit.prevent="onSubmit">
    <base-alert text="password_rule" type="info" />
    <!-- Errors -->
    <FormError :errors="errors" />

    <!-- Form -->
    <base-input-password v-model="form.new_password" label="password" size="lg" focused />
    <base-input-password v-model="form.renew_password" label="password2" size="lg" />

    <!-- Action buttons -->
    <base-spacer />
    <base-button
      type="submit"
      size="lg"
      class="w-full"
      :action="type === 'reset' ? 'reset_password' : 'activate_account'"
      :loading="pendingRequest"
      :disabled="$v.form.$invalid"
    />
  </form>
</template>

<script>
import {BaseButton, BaseAlert, BaseInputPassword, BaseSpacer} from '@/components/base'
import FormError from '@/components/shared/FormError'
import {required, sameAs, helpers} from 'vuelidate/lib/validators'

const _passwordValidator = helpers.regex('password', /^(?=.*\d)(?=.*[a-zA-Z])(?!.*\s).{8,}$/)

export default {
  components: {
    BaseSpacer,
    BaseAlert,
    FormError,
    BaseButton,
    BaseInputPassword,
  },

  props: {
    type: String, // reset | activate
    required: true,
  },

  data() {
    return {
      pendingRequest: false,
      errors: {},
      form: {
        new_password: '',
        renew_password: '',
      },
    }
  },

  methods: {
    // ================================================================================
    // Events
    // ================================================================================

    async onSubmit() {
      if (this.pendingRequest || this.$v.form.$invalid) {
        return
      }

      try {
        this.pendingRequest = true
        this.errors = {}
        const payload = {password: this.form.new_password, password2: this.form.renew_password}
        let action = ''
        let notificationText = ''
        let emitEvent = ''
        if (this.type === 'reset') {
          action = 'users/resetPassword'
          notificationText = 'password_reset'
          emitEvent = 'reset'
        } else {
          action = 'users/activateUser'
          notificationText = 'account_activated'
          emitEvent = 'activated'
        }
        await this.$store.dispatch(action, payload)
        this.$store.dispatch('app/notification', {
          type: 'success',
          group: 'auth',
          text: notificationText,
        })
        this.$emit(emitEvent)
      } catch (errors) {
        this.errors = errors
        this.$store.dispatch('app/notification', {type: 'error', group: 'app', text: 'updated'})
      } finally {
        this.pendingRequest = false
      }
    },
  },

  // ================================================================================
  // Validation
  // ================================================================================
  validations: {
    form: {
      new_password: {required, _passwordValidator},
      renew_password: {required, sameAs: sameAs('new_password')},
    },
  },
}
</script>
